import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import htmlToImage from 'html-to-image';
import { CustomDynamicFormControlComponent } from '../custom-dynamic-form-control.component';
import { KfzTypEnum } from '../shared-models/kfz-type.model';
import { CollisionPickerModel } from './collision-picker.model';

const backgroundImages = {
  [KfzTypEnum.PKW]:       '../../../assets/gsm/pkw.svg',
  [KfzTypEnum.LKW]:       '../../../assets/gsm/lkw.svg',
  [KfzTypEnum.MOTORRAD]:  '../../../assets/gsm/motorrad.svg',
  [KfzTypEnum.TRAKTOR]:   '../../../assets/gsm/traktor.svg',
  [KfzTypEnum.TRIKE]:     '../../../assets/gsm/trike.svg',
  [KfzTypEnum.BUS]:       '../../../assets/gsm/bus.svg',
  [KfzTypEnum.ANHAENGER]: '../../../assets/gsm/anhaenger.svg'
};

@Component({
  selector:    'gsm-collision-picker',
  templateUrl: './collision-picker.component.html',
  styleUrls:   ['./collision-picker.component.scss'],
  standalone:  true,
  imports:     [
    NgIf,
    NgClass,
    NgFor
  ]
})
export class CollisionPickerComponent extends CustomDynamicFormControlComponent<CollisionPickerModel> implements OnInit {

  @ViewChild('container') containerElem: ElementRef;

  selection: number[] = [];

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected onModelChange() {
    if (this.model.value) {
      this.selection = this.model.value.selection || [];
    }
    this._updateModel();
    this.change.emit(this.model.value);
  }

  private _updateModel() {
    this.model.value = {
      selection:         this.selection,
      getScreenshotFile: () => this._getScreenshotFile()
    };
  }

  backgroundImagePath(): string {
    return (backgroundImages[this.model.kfzTyp?.skizzeId] || '');
  }

  updateKfzIndex(index: number) {
    if (this.selection.includes(index)) {
      this.selection = this.selection.filter(item => item !== index);
    } else {
      this.selection = [
        ...this.selection,
        index
      ];
    }

    this._updateModel();
    this.change.emit(this.model.value);
  }

  private async _getScreenshotFile(): Promise<File> {
    const blob = await htmlToImage.toBlob(this.containerElem.nativeElement, {
      width:           164,
      height:          283,
      backgroundColor: '#D3D3D3'
    });
    return new File([blob], 'kfz-schaden.png', {
      type: 'image/png'
    });
  }
}
